import React from 'react';

/**
 * MessageBox Component
 * 
 * Displays a dismissible Bootstrap-style alert at the top of your page.
 * Props:
 * - message: string (the main alert text)
 * - type: string ('success', 'danger', 'warning', 'info', etc. - Bootstrap color modifier)
 * - onClose: function (called when the user presses the close button)
 */
const MessageBox = ({ message, type, onClose }) => {
  const alertClass = `alert alert-${type || 'info'} alert-dismissible fade show w-75 mx-auto my-3`;

  if (!message) return null;

  return (
    <div className={alertClass} role="alert">
      {message}
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
        onClick={onClose}
      ></button>
    </div>
  );
};

export default MessageBox;
